import { useEffect, useState, useRef, useCallback } from 'sb-hooks'


const useExpired = (values) => {
  const {
    initialTime = 20 * 60 * 1000, // 20 min
  } = values

  const initTime    = initialTime
  const tickTime    = 1000
  const timeLeft    = useRef(initTime)
  const timer       = useRef(null)

  const [ isExpired, setExpired ] = useState(timeLeft.current <= tickTime)

  const tick = useCallback(() => {
    timeLeft.current -= tickTime

    if (timeLeft.current <= 0) {
      clearInterval(timer.current)
      setExpired(true)

      return
    }
  }, [])

  useEffect(() => {
    if (!isExpired) {
      timer.current = setInterval(tick, tickTime)
      tick()
    }

    return () => {
      clearInterval(timer.current)
    }
  }, [])

  return {
    isExpired,
  }
}


export default useExpired
